import SmartContextAnalytics from './SmartContextAnalytics';

export default SmartContextAnalytics;
